/* References:
   [1]: https://codingbeautydev.com/blog/javascript-resolve-promise-from-outside/
   [2]: https://www.npmjs.com/package/my-deferred (for a more featureful implementation)
   [3]: https://dev.to/noseratio/we-can-make-any-javascript-object-await-able-with-then-method-1apl
   [4]: https://gist.github.com/noseratio/da756d5bd1360cafa6eabc4d475a9ab7
*/
class Deferred {
  constructor() {
    const promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });

    /** @type {Promise["then"]} */
    this.then = promise.then.bind(promise); // [3]

    /** @type {Promise} */
    this.promise = promise;
  }

  resolve(value) {
    this._resolve(value);
  }

  reject(reason) {
    this._reject(reason);
  }
}

export default Deferred;
